import type { FileTreeType as FileTreeTypeApi } from 'src/api/generated/touring/types';
import { mapFilesResponseType } from '../mapFilesResponseType';
import { MappedFileTreeType } from './types';

export const mapFileTreeType = (
  apiType: FileTreeTypeApi
): MappedFileTreeType => {
  return {
    locationId: apiType.locationId,
    files: mapFilesResponseType(apiType.files),
    isInitiallyExpanded: apiType.isInitiallyExpanded,
  };
};
